import { IUsedImageCollection } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

// 컬렉션 리스트 내 보여줄 리스트 아이템으로서의 '사용한 이미지' 컬렉션
async function getUsedImageCollection(imageId?: number): Promise<AxiosResponse<FetchResult<IUsedImageCollection>>> {
  const response = await instance.get(
    imageId ? `/images/used-images/preview?imageId=${imageId}` : `/images/used-images/preview`
  );
  return response;
}

const useFetchUsedImageCollection = (needFetch: boolean, imageId?: number) => {
  const { data: originalData } = useQuery({
    queryKey: ['get', imageId ? `/images/used-images/preview?imageId=${imageId}` : `/images/used-images/preview`],
    queryFn: () => getUsedImageCollection(imageId),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: needFetch
  });

  const data = originalData?.data.data;

  return { data };
};

export default useFetchUsedImageCollection;
